'use client';

import { Button, Grid, Stack, Typography } from '@mui/material';
import Link from 'next/link';
import { IconBadge } from '../../components/iconBadge';

/**
 * NotFoundPage component renders a custom 404 error page.
 *
 * It includes a doodle illustration, error message, and a button to
 * navigate back to the homepage.
 *
 * @returns {React.JSX.Element} The rendered NotFoundPage component.
 */

export const NotFoundPage = () => {
  return (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center',
        gap: 4,
        height: '100%',
        width: '100%',
        paddingBottom: { xs: 4, md: 0 },
      }}
      data-testid="not-found-page"
    >
      <Stack
        sx={{
          alignItems: 'center',
          gap: 4,
        }}
      >
        <IconBadge icon="explore_off" tone="brand" />
        <Stack
          sx={{
            gap: 2,
          }}
        >
          <Typography variant="h1">¡Ups! Algo salió mal</Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
            }}
          >
            La página no existe
          </Typography>
        </Stack>
      </Stack>
      <Button component={Link} href="/" fullWidth variant="contained">
        Volver al inicio
      </Button>
    </Grid>
  );
};
